// extracted by mini-css-extract-plugin
export default {"StatDisplay":"StatDisplay_StatDisplay__8C05+","Stat":"StatDisplay_Stat__MWMBB","Icon":"StatDisplay_Icon__IrXco","Label":"StatDisplay_Label__BJyc8"};